import { render, staticRenderFns } from "./CampusRunTaskAction.vue?vue&type=template&id=b2bdbd3c&scoped=true&"
import script from "./CampusRunTaskAction.vue?vue&type=script&lang=ts&"
export * from "./CampusRunTaskAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bdbd3c",
  null
  
)

export default component.exports